import { render, staticRenderFns } from "./ReadyMade.vue?vue&type=template&id=d8b5b6c8&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ReadyMade.vue?vue&type=script&lang=js&"
export * from "./ReadyMade.vue?vue&type=script&lang=js&"
import style0 from "./ReadyMade.vue?vue&type=style&index=0&id=d8b5b6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b5b6c8",
  null
  
)

export default component.exports